import { Component } from '@angular/core';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { Platform } from '@ionic/angular';
import { ApiService } from '../api.service';
import { LocationService } from '../location.service';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-vendor-profile-view',
  templateUrl: './vendor-profile-view.component.html',
  styleUrls: ['./vendor-profile-view.component.scss'],
})
export class VendorProfileViewComponent  {
  loader:boolean = true;
  mob;
  url;
  id; 
  img;
  radius;
  wallet:boolean;
  details;
  newSearch;
  getId;
  getData;
  contactNbrMob;
  firstName;
  name;
  housenbr;
  street;
  city;
  region;
  state;
  zipcode;
  numb="+91";
  id1;
  CreatedBy;
  button:boolean;
  active: boolean = true;
  costPerService;
  confirm:boolean;
  rej:boolean;
  vendorcredits;
  constructor(private socialSharing: SocialSharing,private router: Router, public handler: HandlerService, private platform: Platform,
   public service: ApiService,public location: LocationService,public auth:AuthService) { }
  
  
    ionViewWillEnter(){
      this.url = window.location.href;
      this.id = this.url.split('/').pop();
      this.basicDetails();
      if(this.url.includes('vendorProfileViewUser')){
        this.button = true;
      }else{
        this.button = false;
      }
   }
  
   
  basicDetails(){      
    if (this.url.includes('vendorProfileView') || this.url.includes('contractorProfileView')){
    this.service.getAddressById(this.id).subscribe(res => {
      this.getData = res;
      this.img=this.getData.profilePic;
      this.name= this.getData.firstName;
      this.radius = this.getData.serviceRadius;
      this.mob=this.getData.contactNbrMob.slice(-10);
      this.id1 = this.getData.roles[0]?.roleId;
      if(this.getData.billingConfigs){
        if(this.getData.billingConfigs[0]){
          this.costPerService = this.getData.billingConfigs[0].costPerService;
        }
      }
      if(this.getData.addresses){
      if(this.getData.addresses[0]){
        if(this.getData.addresses[0].houseNbr)
        this.location.houseNbr=this.getData.addresses[0].houseNbr;
        if(this.getData.addresses[0].street)
        this.location.street=this.getData.addresses[0].street;
        if(this.getData.addresses[0].cityId)
        this.location.cityId=this.getData.addresses[0].cityId;
        if(this.getData.addresses[0].regionId)
        this.location.regionId=this.getData.addresses[0].regionId;
        if(this.getData.addresses[0].stateId)
        this.location.stateId=this.getData.addresses[0].stateId;
        if(this.getData.addresses[0].zipcode)
        this.location.zipcode=this.getData.addresses[0].zipcode;  
      
    }
  }
      this.loader = false;
      });
    }
  }
   updateUser(){
    this.loader = true;
    this.getId=localStorage.getItem('vendoruserId')
    this.getData.firstName = this.name.toUpperCase();
    this.getData.contactNbrMob = this.numb+this.mob;
    this.getData.profilePic=this.img;
    let x;
    var data = {
      houseNbr : this.location.houseNbr,
      street : this.location.street,
       cityId :this.location.cityId,
       regionId : this.location.regionId,
       stateId : this.location.stateId,
       zipcode : this.location.zipcode,
       lat : this.location.lat,
       lon  : this.location.lon,
        type: 1,
        userId: localStorage.getItem('currentUserId'),
        orgId: localStorage.getItem('organizationId'),
    }
    Object.assign(this.getData,{lat : this.location.lat,
      lon  : this.location.lon,
      serviceRadius:this.radius})
      if(!this.getData.addresses)
      Object.assign(this.getData,{addresses:[]})
      
      if (this.getData.addresses.length == 0){
        this.getData.addresses.push(data);    
      }
      else{
        x=this.getData.addresses.findIndex(res=>res.type==1);
        this.getData.addresses[x]=data;      
       }
     this.getData.activeInd=this.active;
     if(this.getData.billingConfigs){  
    this.getData.billingConfigs[0].costPerService = this.costPerService;
     }
    this.service.postProfileDetails(this.id,this.getData).subscribe(res=>{
     if(this.vendorcredits){
      this.postVendorCredits();
     }else{ 
      this.basicDetails();
     }
    this.handler.res('Profile Details Updated Successfully')
    if(this.url.includes('vendorProfileViewUser')){
      this.router.navigate(['vendorProfile/',+ this.id])
    }else{
      this.router.navigate(['/vendorAdminProfile'])
    }
  
    this.loader = false;
  },err=>{
    this.handler.err(err)
    this.loader=false;
  }) 
  }
  postVendorCredits(){
    this.service.postCreadits(this.id,this.vendorcredits).subscribe(res=>{
      this.vendorcredits=''
      this.basicDetails();
    },err=>{
      this.handler.staticError(err);
    }) 
  }
   logout(){
     localStorage.removeItem('mobile')
   }
   onInput() {
    this.location.autoComplete();
    }

    ionViewWillLeave(){
     this.location.houseNbr="";
     this.location.street="";
     this.location.cityId="";
     this.location.regionId="";
     this.location.stateId="";
     this.location.zipcode="";
     this.location.lat="";
     this.location.lon="";
     this.location.newSearch="";
     this.mob="";
     this.name="";
    }

    approval(){
      this.service.vendorApproval(this.id,this.id1).subscribe(res=>{
        this.confirm=false;
       this.router.navigate(['/vendor-approval']);
      })
    }

    reject(){
      this.service.vendorReject(this.id,this.id1).subscribe(res=>{
        this.rej=false;
        this.router.navigate(['/vendor-approval']);
       })
     }

     handleFile1(files) {
       console.log("1")
      if(files[0].size < 1048576){
        var img = new Image();
        img.src = URL.createObjectURL(files[0]);
        img.onload = (data)=>{
          var canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0,0);  
          this.img = canvas.toDataURL('image/jpeg',0.07);
        }
      }
      else{
        this.handler.res('Image Size Should Not Exceeds 1mb ');
      }
  }
 }
 